import React, {useState} from "react";
import {Route} from "@/routing/Router";
import DeliveryAreasHeading from "@widgets/deliveryAreas/overview/heading/DeliveryAreasHeading";
import DeliveryAreasTable from "@widgets/deliveryAreas/overview/table/DeliveryAreasTable";
import {EditDeliveryAreaState} from "@widgets/deliveryAreas/edit/EditDeliveryAreaModal";

type Props = {
    route: Route,
};

const DeliveryAreasOverview = ({route}: Props) => {
    const [editModal, setEditModal] = useState<EditDeliveryAreaState>({showModal: false, deliveryArea: null});

    return (
        <>
            <DeliveryAreasHeading
                route={route}
                setEditModal={setEditModal}
            />

            <div className={"mt-6 md:mt-12"}>
                <DeliveryAreasTable
                    editModal={editModal}
                    setEditModal={setEditModal}
                />
            </div>
        </>
    );
};

export default DeliveryAreasOverview;